import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getTransportPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/odvetvi/preprava",
		[Locale.en]: "/industries/transport",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
